import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { choose_ticket } from "../redux/actions";
import { Popup } from "./Popup";

function ticket_summ(item) {
    let summ = 0;
    summ += item.fixed_commission ? item.fixed_commission : 0;
    summ += item.air_waybill ? item.air_waybill : 0;
    summ += item.air_waybill_t ? item.air_waybill_t : 0;
    summ += item.air_waybill_l ? item.air_waybill_l : 0;
    summ += item.weight_commission ? item.weight_commission : 0;
    summ += item.weight_commission_t ? item.weight_commission_t : 0;
    summ += item.weight_commission_l ? item.weight_commission_l : 0;
    summ += item.tarif_commission ? item.tarif_commission : 0;
    summ += item.tarif_commission_t ? item.tarif_commission_t : 0;
    summ += item.tarif_commission_l ? item.tarif_commission_l : 0;
    summ += item.declaration_commission ? item.declaration_commission : 0;
    summ += item.declaration_commission_t ? item.declaration_commission_t : 0;
    summ += item.declaration_commission_l ? item.declaration_commission_l : 0;
    summ += item.advanced_commission ? item.advanced_commission : 0;
    summ += item.advanced_commission_t ? item.advanced_commission_t : 0;
    summ += item.advanced_commission_l ? item.advanced_commission_l : 0;
    summ += item.registration_commission ? item.registration_commission : 0;
    summ += item.registration_commission_t ? item.registration_commission_t : 0;
    summ += item.registration_commission_l ? item.registration_commission_l : 0;
    summ += item.car_to_aeroport ? item.car_to_aeroport : 0;
    summ += item.car_from_aeroport ? item.car_from_aeroport : 0;
    summ += item.base_commission ? item.base_commission : 0;
    let nalog = Math.round(summ * (100 / 98.5 - 1));
    summ += nalog;
    return summ;
}

export const Tickets = () => {
    const dispatch = useDispatch();
    const avia = useSelector((state) => state.app.avia);
    const tickets_loading = useSelector((state) => state.app.tickets_loading);
    const tickets_error = useSelector((state) => state.app.tickets_error);
    const tickets_btn = useSelector((state) => state.app.tickets_btn);
    const tickets = useSelector((state) => state.app.tickets);
    let totalVolume = useSelector((state) => state.app.totalVolume);
    const totalWeight = useSelector((state) => state.app.totalWeight);
    const cargoName = useSelector((state) => state.app.fields.cargoName.value);
    const commision = useSelector((state) => state.app.commision);
    const fields = useSelector((state) => state.app.fields);
    const sizeType = useSelector((state) => state.app.sizeType);
    const ticketsDiv = useRef(null);
    let sizes = useSelector((state) => state.app.fields.sizes);
    let totalPaidWeight = useSelector((state) => state.app.totalPaidWeight);

    const volumeValue = useSelector(
        (state) => state.app.fields.overallVolume.volume.value,
    );

    let min_summ = 10000000;
    let paid_weight = 0;
    let places = 0;

    if (tickets_loading) {
        return (
            <section
                className="calc-tickets container white-bg"
                id="calc-tickets"
            >
                <div className="container__wrap">
                    <div className="calc-tickets__loader">
                        <span className="spinner spinner_blue spinner_active"></span>
                    </div>
                </div>
            </section>
        );
    }
    if (Object.keys(tickets).length > 0) {
        Object.keys(tickets).map((key) => {
            const summ = Math.round(ticket_summ(tickets[key]));
            tickets[key].summ = summ;
            if (min_summ > summ) {
                min_summ = summ;
            }
            //paid_weight = tickets[key].paid_weight;
            //places = tickets[key].places;
            return null;
        });
    }

    let p_volume_weight = 0;
    let p_weight = 0;
    let temp = 0;

    if (sizeType === 1) {
        temp = Math.ceil(
            Math.cbrt(
                parseFloat(fields.overallVolume.volume.value) /
                    parseFloat(fields.overallVolume.places.value),
            ) * 100,
        );
        //p_volume_weight += parseFloat(temp / 100) * parseFloat(temp / 100) * parseFloat(temp / 100) * parseFloat(fields.overallVolume.places.value);
        p_volume_weight += parseFloat(fields.overallVolume.volume.value);
        p_weight += parseFloat(fields.overallVolume.weight.value);
        places = parseInt(fields.overallVolume.places.value);
        totalVolume = volumeValue;
    }
    if (sizeType === 2) {
        for (let i = 0; i < fields.sizes.length; i++) {
            if (
                fields.sizes[i].sizeLength.value === "" ||
                fields.sizes[i].sizeWidth.value === "" ||
                fields.sizes[i].sizeHeight.value === "" ||
                fields.sizes[i].sizeWeight.value === "" ||
                fields.sizes[i].sizeCounter.value === ""
            ) {
            } else {
                p_volume_weight +=
                    parseFloat(
                        parseInt(fields.sizes[i].sizeLength.value) / 100,
                    ) *
                    parseFloat(
                        parseInt(fields.sizes[i].sizeWidth.value) / 100,
                    ) *
                    parseFloat(
                        parseInt(fields.sizes[i].sizeHeight.value) / 100,
                    ) *
                    parseInt(fields.sizes[i].sizeCounter.value);
                p_weight +=
                    parseFloat(parseInt(fields.sizes[i].sizeWeight.value)) *
                    parseInt(fields.sizes[i].sizeCounter.value);
                places += parseInt(fields.sizes[i].sizeCounter.value);
            }
        }
        totalVolume = 0;
        sizes.map((item, index) => {
            let length = parseInt(item.sizeLength.value);
            let width = parseInt(item.sizeWidth.value);
            let height = parseInt(item.sizeHeight.value);
            let counter = parseInt(item.sizeCounter.value);
            let volume = 0;
            if (length > 0 && width > 0 && height > 0) {
                volume = (length * width * height) / 1000000;
            }
            totalVolume += volume * counter;
            return null;
        });
    }
    if (p_weight > p_volume_weight * 167) {
        paid_weight = p_weight;
    } else {
        paid_weight = p_volume_weight * 167;
    }
    if (isNaN(paid_weight)) {
        paid_weight = 0;
    }

    const handleCallManagerClick = (data, sizeType) => {
        let comment = "";
        comment += "Откуда: " + data.cityFrom.value + "\n";
        comment += "Куда: " + data.cityTo.value + "\n";
        comment += "Дата: " + new Date(data.departureDate.value).toLocaleDateString('ru-RU') + "\n";
        comment += "Наименование груза: " + data.cargoName.value + "\n";

        if (sizeType === 1) {
            comment += "Общий объем: \n";
            comment += "Кол-во мест: " + data.overallVolume.places.value + "\n";
            comment += "Вес груза: " + data.overallVolume.weight.value + "\n";
            comment += "Объем: " + data.overallVolume.volume.value + "\n";
        }
        if (sizeType === 2) {
            comment += "Указать габариты: \n";
            for (let i = 0; i < data.sizes.length; i++) {
                comment += "Указать габариты: \n";
                comment +=
                    fields.sizes[i].sizeLength.value +
                    "см x " +
                    fields.sizes[i].sizeWidth.value +
                    "см x " +
                    fields.sizes[i].sizeHeight.value +
                    "см | " +
                    fields.sizes[i].sizeWeight.value +
                    "кг x " +
                    fields.sizes[i].sizeCounter.value;
            }
        }
    };

    function change_data() {
        document
            .getElementById("front-calc")
            .scrollIntoView({ behavior: "smooth" });
    }

    if (Object.keys(tickets).length > 0 || tickets_error.length > 0) {
        return (
            <React.Fragment>
                <section
                    className="calc-tickets container white-bg"
                    id="calc-tickets"
                    ref={ticketsDiv}
                >
                    <div className="calc-tickets__wrap container__wrap">
                        <div className="calc-tickets__flex">
                            <div className="calc-tickets__sidebar">
                                <div className="calc-tickets__params">
                                    <ul>
                                        <li>
                                            <span>Наименование груза:</span>
                                            <span>{cargoName}</span>
                                        </li>
                                        <li>
                                            <span>Кол-во мест:</span>
                                            <span>{places}</span>
                                        </li>
                                        <li>
                                            <span>Вес груза (общий):</span>
                                            <span>
                                                {totalWeight.toFixed(2)} кг
                                            </span>
                                        </li>
                                        <li>
                                            <span>Объем груза (общий):</span>
                                            <span>
                                                {parseFloat(
                                                    totalVolume,
                                                ).toFixed(3)}{" "}
                                                м3
                                            </span>
                                        </li>
                                        <li>
                                            <span>Оплачиваемый вес:</span>
                                            <span>
                                                {totalPaidWeight.toFixed(2)} кг
                                            </span>
                                        </li>
                                    </ul>
                                    <div
                                        className="calc-tickets__params_btn"
                                        onClick={() => change_data()}
                                    >
                                        Изменить данные
                                    </div>
                                </div>

                                <div className="calc-tickets__attach_message">
                                    <div className="calc-tickets__attach_message_heading">
                                        Обратите внимание!
                                    </div>
                                    <div className="calc-tickets__attach_message_line" />
                                    <div className="calc-tickets__attach_message_text">
                                        Мы работаем с юридическими лицами и
                                        можем перевезти ваш груз{" "}
                                        <strong>
                                            только при наличии документов.
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div className="calc-tickets__content">
                                {tickets_error.length > 0 && (
                                    <div className="calc-tickets__error">
                                        {tickets_error}
                                        {tickets_btn === 1 && (
                                            <div
                                                className="calc-tickets__error_btn"
                                                onClick={() => {
                                                    console.log(fields);
                                                    console.log(sizeType);
                                                    return handleCallManagerClick(
                                                        fields,
                                                        sizeType,
                                                    );
                                                }}
                                            >
                                                {tickets_error.indexOf(
                                                    "импортный расчет",
                                                ) > 0 && (
                                                    <React.Fragment>
                                                        Получить расчет на почту
                                                    </React.Fragment>
                                                )}
                                                {tickets_error.indexOf(
                                                    "импортный расчет",
                                                ) < 0 && (
                                                    <React.Fragment>
                                                        Связаться с менеджером
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {Object.keys(tickets).length > 0 &&
                                    Object.keys(tickets).map((key) => {
                                        let item = tickets[key];
                                        const summ = Math.round(
                                            item.summ * commision,
                                        );
                                        const summ_kg = Math.round(
                                            summ / item.paid_weight,
                                        );

                                        return (
                                            <div
                                                key={key}
                                                className="calc-tickets__item"
                                                onClick={() =>
                                                    dispatch(
                                                        choose_ticket(item),
                                                    )
                                                }
                                            >
                                                <div className="calc-tickets__item_info">
                                                    {Math.round(
                                                        min_summ * commision,
                                                    ) === summ && (
                                                        <div className="calc-tickets__item_label blue">
                                                            самый дешевый
                                                        </div>
                                                    )}
                                                    {1 === 2 && (
                                                        <div className="calc-tickets__item_label1">
                                                            Сроки доставки
                                                        </div>
                                                    )}
                                                    {1 === 2 && (
                                                        <div className="calc-tickets__item_sum1">
                                                            Уточняйте у
                                                            менеджера
                                                        </div>
                                                    )}
                                                    <div className="calc-tickets__item_label2">
                                                        Стоимость доставки
                                                    </div>
                                                    <div className="calc-tickets__item_sum2">
                                                        {summ} руб
                                                    </div>
                                                    <div className="calc-tickets__item_sum3">
                                                        {summ_kg} руб/кг
                                                    </div>
                                                    <div className="calc-tickets__item_more">
                                                        подробнее
                                                    </div>
                                                </div>
                                                <div className="calc-tickets__item_pathes">
                                                    {item.short_path.length >
                                                        0 &&
                                                        item.short_path.map(
                                                            (path, index) => {
                                                                if (
                                                                    path.type &&
                                                                    path.type ===
                                                                        "text"
                                                                ) {
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                            className="calc-tickets__item_path text"
                                                                        >
                                                                            <span>
                                                                                {
                                                                                    path.name
                                                                                }
                                                                            </span>
                                                                            <span>
                                                                                {
                                                                                    path.country
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                }
                                                                if (
                                                                    path.type &&
                                                                    path.type ===
                                                                        "img"
                                                                ) {
                                                                    const airline =
                                                                        path.airline;
                                                                    let img =
                                                                        path.img;
                                                                    avia.map(
                                                                        (
                                                                            avia_item,
                                                                        ) => {
                                                                            if (
                                                                                airline.toLowerCase() ===
                                                                                avia_item.code.toLowerCase()
                                                                            ) {
                                                                                img =
                                                                                    avia_item.gray_image;
                                                                            }
                                                                            return null;
                                                                        },
                                                                    );
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                            className="calc-tickets__item_path img"
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    img
                                                                                }
                                                                                alt=""
                                                                                title=""
                                                                            />
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            },
                                                        )}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                        <Popup />
                    </div>
                </section>
            </React.Fragment>
        );
    }
    return null;
};
